import React from 'react'
import Price from 'app/React/Components/Footer/Price'

export default function SecurityDeposit({ type = 'security-deposit' }) {
  return (
    <div className='security-deposit'>
      <Price format='cash' type={type} />
    </div>
  )
}
